<common-navigation></common-navigation>

<div class="default-box d-flex align-items-center mx-auto col-md-5 col-lg-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-xl-12 mb-100">
                <div id="page-redirection">
                    <a routerLink="/sign-in">
                        <img src="../../../../assets/images/arrows/back_arrow.png">
                        Back to sign in
                    </a>
                </div>

                <h3 class="display-4 box-title">Forgot Password</h3> <br>
                <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="error">
                   <button type="button" class="close" data-dismiss="alert">&times;</button>
                   {{errorMsg}}
                </div>
                <div class="alert alert-success alert-dismissible fade show" role="success" *ngIf="success">
                  <button type="button" class="close" data-dismiss="alert">&times;</button>
                  We have e-mailed your password reset link.
                </div>
                <form [formGroup]="signInForm" (ngSubmit)="onSubmit()">
                    <div class="md-input">
                        <input class="md-form-control"
                               required
                               type="text"
                               formControlName="email"
                               [ngClass]="{'error': (submitted && signInForm.invalid && f.email.invalid) || (f.email.dirty && f.email.invalid)}"
                        >
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label>Email</label>
                    </div>

                    <button type="submit" class="btn btn-primary btn-block btn-submit"  [disabled]="loading">Send Reset
                      <img src="../../../../assets/images/loader.gif" *ngIf="loading"></button>
                </form>
            </div>
        </div>
    </div>
</div>
